import React, { useEffect, useState, useCallback } from "react";
import theme from "../../theme";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import debounce from "lodash.debounce";
import {format} from "date-fns";

import BackButton from "../../components/common/BackButton"

import GenericTableComponent from "../../components/common/Table";
import { getDailyCampaign } from "../../redux/slices/reportSlice";

import Swal from "sweetalert2";

import {
    Container
  } from "./ReportsStyles";

  const columns = [
    { id: "campaignName", label: "Campaign Name" },
    { id: 'reach', label: 'Clicks' },
    { id: 'totalConversion', label: 'Conversions' },
    { id: 'amountSpent', label: 'Amount' },
    //{ id: "conversionrate", label: "CR" },
    //{ id: "ecpm", label: "eCPM" },
    // { id: "campaignBudget", label: "Budget" },
    // { id: 'costPerUser', label: 'CPA' },
    // { id: "campaignReference", label: "Campaign ID" },
    // { id: "carrier", label: "Carrier" },
    // { id: "flow", label: "Flow" },
    // { id: "isApproved", label: "Approval" },
  ];

const DailyCampaign = () => {
  const dispatch = useDispatch();
  const { dailyCampaign, meta, loading } = useSelector((state) => state.report);
  
   const [searchParams] = useSearchParams();
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [exportData] = useState(true)
  const [exportLoading, setExportLoading] = useState(false);
  
  useEffect(() => {
    dispatch(getDailyCampaign({startDate, endDate, page, rowsPerPage}))
  }, [dispatch, page, rowsPerPage, startDate, endDate]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
    dispatch(getDailyCampaign({ startDate, endDate, page: newPage, rowsPerPage }));
  };
  
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    dispatch(getDailyCampaign({ startDate, endDate, page: 0, rowsPerPage: newRowsPerPage }));
  };

  const debouncedSearch = useCallback(
    (searchTerm) => {
      const debouncedFn = debounce(() => {
        dispatch(getDailyCampaign({ startDate, endDate, page: 0, rowsPerPage, name: searchTerm }));
      }, 1000);
  
      debouncedFn();
    },
    [dispatch, rowsPerPage, startDate, endDate]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    
    dispatch(getDailyCampaign({ startDate, endDate, page: 0, rowsPerPage, name: search }));
  };

  const handleExport = async () => {
    try {
      setExportLoading(true);
      
      const response = await 
              dispatch(getDailyCampaign({startDate, endDate, exportData})).unwrap();
      // Get the file URL from the response
      if (response.data.file) {
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = response.data.file;
        link.setAttribute('download', `Daily-campaign-report.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        Swal.fire({
          title: 'Export Status',
          text: response.data.message || 'No file available for download',
          icon: 'info',
          confirmButtonColor: theme.color.brand
        });
      }
    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        title: 'Export Failed',
        text: error.message || 'Failed to export publisher details',
        icon: 'error',
        confirmButtonColor: theme.color.brand
      });
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <Container>
        <div className="heading">
        <div className="texts">
          <h1>Daily Report Details ({format(startDate, "MMM dd, yyyy")})</h1>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
          <BackButton></BackButton>
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          <Link className="add-campaign" onClick={handleExport} disabled={exportLoading}>
            {exportLoading ? 'Exporting...' : 'Export CSV'}
          </Link>
        </div>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={dailyCampaign}
          //filterSearch={true}
          paginate={false}
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
          hideSelector
        />
      )}
    </Container>
  );
};

export default DailyCampaign;
